var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:_vm.handleModifierClass,on:{"change":function($event){_vm.changed = true}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }